import React from "react";

const FrenchGelerationProcess = () => {
  return (
    <div className="nailExtensionHeading">
      <h4>The Process of Nails Color Change in Bangalore at SCENT</h4>
      <p>
        Getting a nails color change in Bangalore at SCENT is a delightful
        experience. Here’s a step-by-step overview of what you can expect during
        your visit:
      </p>
      <ul>
        <li>
          <h6>1. Consultation:</h6> Your visit begins with a consultation to
          understand your preferences and any specific requirements. Our
          technicians will help you choose the best shades and styles for your
          French nails.
        </li>
        <li>
          <h6>2. Nail Preparation:</h6> Your nails will be cleaned, trimmed, and
          shaped to your liking. The cuticles will also be carefully groomed to
          ensure a clean base for the gel application.
        </li>
        <li>
          <h6>3. Base Application:</h6> A base coat of gel polish is applied and
          cured under a UV or LED lamp. This step is crucial for ensuring the
          longevity of the gel manicure.
        </li>
        <li>
          <h6>4. Finishing Touches:</h6> Once the color is applied, we will add
          any finishing touches, such as a top coat or nail art, to enhance the
          look.
        </li>
        <li>
          <h6>5. White Tips: </h6> Our technicians will provide you with tips on
          how to maintain your nails and make the color last longer. Regular
          care and touch-ups can keep your nails looking fabulous.
        </li>
        <li>
          <h6>6. Top Coat and Finishing:</h6> A top coat is applied to seal the
          look and add extra shine. Your nails are then cured once more, and any
          final touches are made to perfect the manicure.
        </li>
        <li>
          <h6>7. Aftercare Advice:</h6> We provide you with tips and advice on
          how to maintain your French gel nails, ensuring they stay beautiful
          for as long as possible.
        </li>
      </ul>
    </div>
  );
};

export default FrenchGelerationProcess;
